// as per https://github.com/vuejs/vue-cli/issues/1104, ts-ignore directive if ts apart from .vue
// @ts-ignore
import AnalysisSMSCalls from '@/components/analysis/AnalysisSMSCalls/AnalysisSMSCalls.vue'
export default AnalysisSMSCalls
